import React from 'react'
import classNames from 'classnames'
import { CheckBox } from '@st-operations/uikit/src/v2/index.js'

import './styles.scss'

const CustomCheckbox = ({ className, disabled, ...props }) => {
  return (
    <CheckBox
      className={classNames(
        'custom-checkbox',
        { 'custom-checkbox--disabled': disabled },
        className,
        {
          'opacity-50': disabled,
        }
      )}
      disabled={disabled}
      {...props}
    />
  )
}

export default CustomCheckbox
